import { render, staticRenderFns } from "./main.tarifa-iva.vue?vue&type=template&id=16487420"
import script from "./main.tarifa-iva.vue?vue&type=script&lang=js"
export * from "./main.tarifa-iva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports